import enLang from "./entries/en-US"
import idLang from "./entries/id_ID"

const AppLocale = {
  en: enLang,
  id: idLang,
}

export default AppLocale
